import React from 'react';
import './App.css';
import PeriodicElementFamily from './PeriodicElementFamily';
import DnsList from "./DnsList";

const FAMILY_MEMBERS = [
    { name: "Kseniya", element: "Ksu", number: "1", weight: "1.985", color: "#FB75E4" },
    { name: "Thomas",  element: "To",  number: "2", weight: "19.84", color: "#61DAFB" },
    { name: "Noah",    element: "No",  number: "3", weight: "20.16", color: "#FB536C" },
    { name: "Thaïs",   element: "Ta",  number: "4", weight: "20.19", color: "#FBD943" },
    { name: "Clément", element: "Cl",  number: "5", weight: "20.25", color: "#48FA91" }
];

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <div className="Mendeleiev">
                    {FAMILY_MEMBERS.map((member) => (
                        <PeriodicElementFamily
                            key={member.number}
                            size={150}
                            {...member}
                        />
                    ))}
                </div>
                <DnsList />
            </header>
        </div>
    );
}

export default App;
